<script setup lang="ts">
import { useDisplay } from 'vuetify'
import BookTutorialImg from '@images/dashboard/book-tutorial.png'
import BookIcon from '@images/dashboard/book-open-reader-solid.svg'

const { smAndDown } = useDisplay()

const BOOK_DEMO_URL = 'https://www.myfuturechoice.com/demo-request'
</script>

<template>
  <VCard class="mb-4 pr-4 elevation-5 h-100 align-content-center need-help-card">
    <VRow
      class="h-100"
    >
      <VCol
        cols="12"
        md="4"
        class="py-0"
        :class="smAndDown ? 'need-help-card__img--sm' : 'h-100'"
      >
        <VImg
          :src="BookTutorialImg"
          height="100%"
          :position="smAndDown ? '' : 'right top'"
          cover
        />
      </VCol>
      <VCol
        cols="12"
        md="8"
        class="d-flex flex-column"
        :class="smAndDown ? 'py-6 pl-6' : ''"
      >
        <VRow class="flex-grow-0">
          <VCol
            cols="12"
          >
            <h2 class="border-b border-secondary pb-1 mb-0">
              {{ $t('pages.dashboard.need_help_card_header') }}
            </h2>
          </VCol>
        </VRow>
        <VRow class="mt-0 flex-grow-1">
          <VCol
            cols="12"
            md="6"
            class="d-flex flex-column"
          >
            <h4 class="my-1">
              {{ $t('pages.dashboard.need_help_card_tutorial_header') }}
            </h4>
            <p class="text-body-2">
              {{ $t('pages.dashboard.need_help_card_tutorial_text') }}
            </p>
            <VSpacer />
            <div>
              <VBtn
                class="submit-btn mt-4"
                prepend-icon="mdi-calendar-month"
                rel="noopener noreferrer"
                rounded="xl"
                target="_blank"
                :href="BOOK_DEMO_URL"
                tonal
              >
                {{ $t('pages.dashboard.need_help_card_tutorial_btn') }}
              </VBtn>
            </div>
          </VCol>
          <VCol
            cols="12"
            md="6"
            class="d-flex flex-column"
          >
            <h4 class="my-1">
              {{ $t('pages.dashboard.need_help_card_resource_library_header') }}
            </h4>
            <p class="text-body-2">
              {{ $t('pages.dashboard.need_help_card_resource_library_text') }}
            </p>
            <VSpacer />
            <div>
              <VBtn
                class="submit-btn mt-4"
                tonal
                rounded="xl"
                :to="{ name: 'resource-library' }"
              >
                <template #prepend>
                  <VImg
                    :src="BookIcon"
                    width="15"
                  />
                </template>
                {{ $t('pages.dashboard.need_help_card_resource_library_btn') }}
              </VBtn>
            </div>
          </VCol>
        </VRow>
      </VCol>
    </VRow>
  </VCard>
</template>

<style lang="scss" scoped>
.need-help-card {
  &__img {
    &--sm {
      height: 10rem;
    }
  }
}
</style>
